export default __webpack_public_path__ + "static/media/IMG_0706 copie.92b5d266.jpg";